import React from "react";
import { CaretRight, CaretDown } from "@phosphor-icons/react";
import { Category, Habit, Day } from "../types";
import { HabitButton } from "./HabitButton";

interface CategorySectionProps {
  category: Category;
  habits: Habit[];
  days: Day[];
  selectedDay: string;
  greyOutEnabled: boolean;
  isCollapsed: boolean;
  pressStartTime: number | null;
  pressScale: number;
  pressedItemId: number | null;
  onCategoryToggle: (categoryId: number) => void;
  onHabitClick: (habit: Habit) => void;
  onPressStart: (habit: Habit, event: React.MouseEvent | React.TouchEvent) => void;
  onPressMove: (event: React.MouseEvent | React.TouchEvent) => void;
  onPressEnd: (habit: Habit) => void;
  onPressCancel: () => void;
}

export const CategorySection: React.FC<CategorySectionProps> = ({
  category,
  habits,
  days,
  selectedDay,
  greyOutEnabled,
  isCollapsed,
  pressStartTime,
  pressScale,
  pressedItemId,
  onCategoryToggle,
  onHabitClick,
  onPressStart,
  onPressMove,
  onPressEnd,
  onPressCancel,
}) => {
  const categoryHabits = habits.filter(habit =>
    habit.categoryId === category.id &&
    (!habit.archived || days.some(day => day.date === selectedDay && day.habits.includes(habit.id)))
  );

  if (categoryHabits.length === 0) return null;

  return (
    <div style={{ width: "100%", marginTop: "20px" }}>
      <h3 
        style={{
          margin: "0 0 12px 0",
          fontSize: "1em",
          color: "#212529",
          display: "flex",
          alignItems: "center",
          userSelect: "none",
          cursor: "pointer"
        }}
        onClick={() => onCategoryToggle(category.id)}
      >
        <span style={{ marginRight: 8 }}>
          {isCollapsed ? <CaretRight size={16} /> : <CaretDown size={16} />}
        </span>
        {category.name}
      </h3>
      {!isCollapsed && (
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {categoryHabits.map(habit => (
            <HabitButton
              key={habit.id}
              habit={habit}
              days={days}
              selectedDay={selectedDay}
              greyOutEnabled={greyOutEnabled}
              pressStartTime={pressStartTime}
              pressScale={pressScale}
              pressedItemId={pressedItemId}
              onPressStart={onPressStart}
              onPressMove={onPressMove}
              onPressEnd={onPressEnd}
              onPressCancel={onPressCancel}
              onClick={onHabitClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};